import { Controller } from "@hotwired/stimulus"
import { Offcanvas } from "bootstrap"

export default class extends Controller {
  static targets = ["sheet", "title", "meta", "gameHoleId", "strokes", "choice", "submit"]
  static values = {
    saveLabel: String,
    updateLabel: String
  }

  disconnect() {
    this.offcanvas?.dispose()
  }

  open(event) {
    event.preventDefault()

    const { holeId, title, meta, score } = event.params

    this.gameHoleIdTarget.value = holeId
    this.titleTarget.textContent = title
    this.metaTarget.textContent = meta
    this.strokesTarget.value = score || ""
    this.submitTarget.value = score ? this.updateLabelValue : this.saveLabelValue
    this.updateChoices(score)

    this.instance.show()
  }

  selectScore(event) {
    const score = event.params.score.toString()

    this.strokesTarget.value = score
    this.updateChoices(score)
  }

  syncSelection() {
    this.updateChoices(this.strokesTarget.value)
  }

  updateChoices(score) {
    const selectedScore = score?.toString()

    this.choiceTargets.forEach((choice) => {
      const selected = choice.dataset.scoreSheetScoreParam === selectedScore
      choice.classList.toggle("selected", selected)
      choice.setAttribute("aria-pressed", selected)
    })
  }

  get instance() {
    this.offcanvas ||= Offcanvas.getOrCreateInstance(this.sheetTarget)
    return this.offcanvas
  }
}
